import { render } from "./navbar.vue?vue&type=template&id=ba8c6a58"
import script from "./navbar.vue?vue&type=script&lang=js"
export * from "./navbar.vue?vue&type=script&lang=js"
script.render = render

export default script